import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../pages/Dashboard/Sidebar/Sidebar";
import Loader from "../Loader/Loader";
import { Link, useParams } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import config from "../../config/config";
import moment from "moment";
import CurrencySymbols from "../../common/CurrencySymbol";

const PosRegisterDetailPage = () => {
  const {
    currencyValues,
    registerConfig,
    dateFormate,
    FractionDigits,
    CurrencySymbol,
  } = useContext(AppContext);
  const paramObject = useParams();
  const token = localStorage.getItem("Token") || "";
  const locationId = localStorage.getItem("Location") || "";
  const [loading, setLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [registerDetails, setRegisterDetails] = useState([]);
  const [additionSubstractionDetails, setAdditionSubstractionDetails] =
    useState([]);
  const [denominations, setDenominations] = useState([]);
  // const [currencyValues, setCurrencyvalues] = useState([]);
    
  // const denominations = currencyValues.filter((value) => value !== "null");

  console.log(paymentMethods, "paymentMethods");
  useEffect(() => {
    const paymentMap = {
      TrackCashInRegister: "Cash",
      TrackChecksInRegister: "Check",
      TrackCreditCardsInRegister: "CreditCard",
      TrackDebitCardsInRegister: "DebitCard",
      TrackGiftcardsInRegister: "GiftCard",
    };

    const updatedPaymentMethods = registerConfig
      .filter(
        (config) =>
          config.AppConfigvalue === "true" && paymentMap[config.AppConfigkey]
      )
      .map((config) => paymentMap[config.AppConfigkey]);

      console.log(updatedPaymentMethods,registerConfig,paymentMap,"updatedPaymentMethods")

    setPaymentMethods(updatedPaymentMethods);
    
  }, [registerConfig]);

  const getApi = () => {
    if (paramObject.id > 0) {
      let paramid = paramObject.id;
      // Find By ID for register
      setLoading(true);
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/getposregisterdetailsbyid?registerId=${paramid}&locationId=${locationId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setRegisterDetails(res.data.ResponseData[0][0]);
          setAdditionSubstractionDetails(res.data.ResponseData[1]);
          setLoading(false);
          //   setAmounts((prevState) => ({
          //     ...prevState,
          //     Cash: res.data.ResponseData[0]?.CashOpenAmount
          //       ? parseFloat(res.data.ResponseData[0].CashOpenAmount).toFixed(2)
          //       : "",
          //     Check: res.data.ResponseData[0]?.CheckOpenAmount
          //       ? parseFloat(res.data.ResponseData[0].CheckOpenAmount).toFixed(2)
          //       : "",
          //     GiftCard: res.data.ResponseData[0]?.GiftCardOpenAmount
          //       ? parseFloat(res.data.ResponseData[0].GiftCardOpenAmount).toFixed(
          //           2
          //         )
          //       : "",
          //     DebitCard: res.data.ResponseData[0]?.DebitCardOpenAmount
          //       ? parseFloat(
          //           res.data.ResponseData[0].DebitCardOpenAmount
          //         ).toFixed(2)
          //       : "",
          //     CreditCard: res.data.ResponseData[0]?.CreditCardOpenAmount
          //       ? parseFloat(
          //           res.data.ResponseData[0].CreditCardOpenAmount
          //         ).toFixed(2)
          //       : "",
          //     CashClosing: res.data.ResponseData[0]?.CashCloseAmount
          //       ? parseFloat(res.data.ResponseData[0].CashCloseAmount).toFixed(2)
          //       : "",
          //     CheckClosing: res.data.ResponseData[0]?.CheckCloseAmount
          //       ? parseFloat(res.data.ResponseData[0].CheckCloseAmount).toFixed(2)
          //       : "",
          //     GiftCardClosing: res.data.ResponseData[0]?.GiftCardCloseAmount
          //       ? parseFloat(
          //           res.data.ResponseData[0].GiftCardCloseAmount
          //         ).toFixed(2)
          //       : "",
          //     DebitCardClosing: res.data.ResponseData[0]?.DebitCardCloseAmount
          //       ? parseFloat(
          //           res.data.ResponseData[0].DebitCardCloseAmount
          //         ).toFixed(2)
          //       : "",
          //     CreditCardClosing: res.data.ResponseData[0]?.CreditCardCloseAmount
          //       ? parseFloat(
          //           res.data.ResponseData[0].CreditCardCloseAmount
          //         ).toFixed(2)
          //       : "",
          //   }));
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  useState (() => {
    axios
    .get(`${config.salesconfigBaseUrl}/sales/getregistercurrencyvalues`, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        Authorization: token,
      },
    })
    .then((response) => {
      const responseData = response.data.ResponseData;

      const currencyLabels = responseData
        .filter(item => item.CurrancyLabel !== "")
        .map(item => item.CurrancyLabel);
      // const currencyValues = responseData
      //   .filter(item => item.CurrancyValue !== "")
      //   .map(item => item.CurrancyValue);
      
      setDenominations(currencyLabels);

      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
    });

    getApi();
  },[])

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link>Register Log Details</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className={"col-lg-12 col-md-12"}>
              <div className="card-body">
                <div className="col-md-12 d-flex gap-4">
                  {/* Left Panel */}
                  <div className="bg-white col-md-4 p-4">
                    <h2 className="text-xl font-bold mb-4">Register Details</h2>
                    <div className="p-4 border border-gray-300 rounded-md bg-white  mb-3">
                      <div className="flex justify-between">
                        <p> Register Log ID:</p>
                        <strong className="ml-auto">
                          {registerDetails?.Id}
                        </strong>
                      </div>
                      <hr></hr>
                      <div className="flex justify-between">
                        <p> Register Name:</p>
                        <strong className="ml-auto">
                          {registerDetails?.RegisterName}
                        </strong>
                      </div>
                      <hr></hr>
                      <div className="flex justify-between">
                        <p> Open Employee:</p>
                        <strong className="ml-auto">
                          {registerDetails?.OpenEmployee}
                        </strong>
                      </div>
                      <hr></hr>
                      <div className="flex justify-between">
                        <p> Close Employee:</p>
                        <strong className="ml-auto">
                          {registerDetails?.CloseEmployee}
                        </strong>
                      </div>
                      <hr></hr>
                      <div className="flex justify-between">
                        <p> Shift Start:</p>
                        <strong className="ml-auto">
                          {moment(registerDetails?.ShiftStartTime).format(
                            `${dateFormate.toUpperCase()} h:mm A`
                          )}
                        </strong>
                      </div>
                      <hr></hr>
                      <div className="flex justify-between">
                        <p> Shift End:</p>
                        <strong className="ml-auto">
                          {registerDetails?.ShiftEndTime
                            ? moment(registerDetails.ShiftEndTime).format(
                                `${dateFormate.toUpperCase()} h:mm A`
                              )
                            : "Register Still Open"}
                        </strong>
                      </div>
                      <hr></hr>
                      <div className="flex justify-between">
                        <p> Notes:</p>
                        <strong className="ml-auto">
                          {registerDetails?.Notes}
                        </strong>
                      </div>
                    </div>
                    <div className="space-y-4">
                      {paymentMethods.map((key, index) => {
                        // Dynamically generate the key for the open amount (e.g. CashOpenAmount, CheckOpenAmount, etc.)
                        // const openAmountKey = `${key}OpenAmount`; // CashOpenAmount, CheckOpenAmount, etc.
                        // const openAmount = registerDetails[openAmountKey] || 0; // Get the open amount from registerDetails
                        // const closeAmountKey = `${key}CloseAmount`;
                        // const closeAmount = registerDetails[closeAmountKey] || 0;
                        // const salesAmountkey = `${key}Sales`;
                        // const salesAmount = registerDetails[salesAmountkey] || 0;
                        // const totalAdditionskey = `${key}TotalAdditions`;
                        // const addAmount = registerDetails[totalAdditionskey] || 0;
                        // const totalsubkey = `${key}TotalSubtractions`;
                        // const subAmount = registerDetails[totalsubkey] || 0;

                        // const difference = (openAmount + salesAmount + addAmount) - (closeAmount + subAmount)

                        const openAmountKey = `${key}OpenAmount`;
                        const openAmount =
                          Number(registerDetails[openAmountKey]) || 0;

                        const closeAmountKey = `${key}CloseAmount`;
                        const closeAmount =
                          Number(registerDetails[closeAmountKey]) || 0;

                        const salesAmountKey = `${key}Sales`;
                        const salesAmount =
                          Number(registerDetails[salesAmountKey]) || 0;

                        const totalAdditionsKey = `${key}TotalAdditions`;
                        const addAmount =
                          Number(registerDetails[totalAdditionsKey]) || 0;

                        const totalSubtractionsKey = `${key}TotalSubtractions`;
                        const subAmount =
                          Number(registerDetails[totalSubtractionsKey]) || 0;

                        const difference =
                          closeAmount +
                          subAmount -
                          (openAmount + salesAmount + addAmount);
                        console.log({
                          openAmount,
                          salesAmount,
                          addAmount,
                          closeAmount,
                          subAmount,
                          difference,
                        });

                        return (
                          <div
                            key={index}
                            className="p-4 border border-gray-300 rounded-md bg-white  mb-3"
                          >
                            <div className="flex justify-between">
                              <p> {key} Open Amount:</p>
                              <strong className="ml-auto">
                                {CurrencySymbols(
                                  Number(openAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </strong>
                            </div>
                            <hr></hr>
                            {key === "Cash" &&
                              registerDetails?.CashOpenAmount > 0 && (
                                <>
                                  {/* Loop through the denominations array and display each one */}
                                  {denominations.map((denomination, index) => {
                                    // Dynamically get the openCurr field from registerDetails
                                    // const openCurrKey = `openCurr${denomination}`;
                                    const openCurrKey = `openCurr${index + 1}`;
                                    const openCurrAmount =
                                      registerDetails[openCurrKey] || 0;


                                    return (
                                      <div key={denomination}>
                                        <div className="flex justify-between">
                                          <p>{denomination}:</p>
                                          <strong className="ml-auto">
                                            {parseFloat(openCurrAmount)}
                                            {/* Display the corresponding openCurr amount */}
                                            {/* {CurrencySymbols(
                                              Number(openCurrAmount),
                                              { CurrencySymbol },
                                              FractionDigits
                                            )}{" "} */}
                                            {/* Fallback to "0.00" if the value is null or undefined */}
                                          </strong>
                                        </div>
                                        {/* Add <hr /> after each denomination */}
                                        {index !== denominations.length && (
                                          <hr />
                                        )}
                                      </div>
                                    );
                                  })}
                                </>
                              )}
                            <div className="flex justify-between">
                              <p> {key} Close Amount:</p>
                              <strong className="ml-auto">
                                {CurrencySymbols(
                                  Number(closeAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </strong>
                            </div>
                            <hr></hr>
                            {key === "Cash" &&
                              registerDetails?.CashCloseAmount > 0 && (
                                <>
                                  {/* Loop through the denominations array and display each one */}
                                  {denominations.map((denomination, index) => {
                                    // Dynamically get the openCurr field from registerDetails
                                    // const closeCurrKey = `closeCurr${denomination}`;
                                    const closeCurrKey = `closeCurr${index + 1}`;
                                    const closeCurrAmount =
                                      registerDetails[closeCurrKey] || 0;
                                    
                                    console.log(closeCurrAmount,"closeCurrAmountcloseCurrAmount")

                                    return (
                                      <div key={denomination}>
                                        <div className="flex justify-between">
                                          <p>{denomination}:</p>
                                          <strong className="ml-auto">
                                            {/* Display the corresponding closeCurr amount */}
                                            {parseFloat(closeCurrAmount)}
                                            {/* {CurrencySymbols(
                                              Number(closeCurrAmount),
                                              { CurrencySymbol },
                                              FractionDigits
                                            )}{" "} */}
                                            {/* Fallback to "0.00" if the value is null or undefined */}
                                          </strong>
                                        </div>
                                        {/* Add <hr /> after each denomination */}
                                        {index !== denominations.length && (
                                          <hr />
                                        )}
                                      </div>
                                    );
                                  })}
                                  <div className="flex justify-between">
                                    <p>Amount of Cash to Deposit In Bank:</p>
                                    <strong className="ml-auto">
                                      {CurrencySymbols(
                                        Number(closeAmount),
                                        { CurrencySymbol },
                                        FractionDigits
                                      )}
                                    </strong>
                                  </div>
                                  <hr></hr>
                                </>
                              )}
                            <div className="flex justify-between">
                              <p>{key} Sales:</p>
                              <strong className="ml-auto">
                                {CurrencySymbols(
                                  Number(salesAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </strong>
                            </div>
                            <hr></hr>
                            <div className="flex justify-between">
                              <p>{key} Total Additions:</p>
                              <strong className="ml-auto">
                                {CurrencySymbols(
                                  Number(addAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </strong>
                            </div>
                            <hr></hr>
                            <div className="flex justify-between">
                              <p>{key} Total Subtractions:</p>
                              <strong className="ml-auto">
                                {CurrencySymbols(
                                  Number(subAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </strong>
                            </div>
                            <hr></hr>
                            <div className="flex justify-between border-t pt-2">
                              <p>Difference:</p>
                              {/* <strong className="ml-auto"> */}
                              <strong className={`ml-auto ${Number(difference) !== 0 ? "text-red-500" : ""}`}>
                                {CurrencySymbols(
                                  Number(difference),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </strong>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Right Panel */}
                  <div className="bg-white col-md-8 p-4">
                    <h2 className="text-xl font-bold mb-4">
                      Additions and Subtractions
                    </h2>
                    <table className="w-full border text-sm">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="p-2 border">Date</th>
                          <th className="p-2 border">Employee</th>
                          <th className="p-2 border">Payment Type</th>
                          <th className="p-2 border">Amount</th>
                          <th className="p-2 border">Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {additionSubstractionDetails.map((transaction) => (
                          <tr key={transaction.Id}>
                            <td className="p-2 border">
                              {moment(transaction.CreatedDate).format(
                                `${dateFormate.toUpperCase()} h:mm A`
                              )}
                            </td>
                            <td className="p-2 border">
                              {transaction.CreatedBy}
                            </td>
                            <td className="p-2 border">
                              {transaction.PaymentType}
                            </td>
                            <td className="p-2 border">
                              {transaction.AddRemoveType === "remove"
                                ? "-"
                                : ""}
                              ${parseFloat(transaction.Amount).toFixed(2)}
                            </td>
                            <td className="p-2 border">
                              {transaction.Comment ||
                                (transaction.AddRemoveType === "remove"
                                  ? "Removed"
                                  : "Added")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* <table className="w-full border text-sm">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="p-2 border">Date</th>
                          <th className="p-2 border">Employee</th>
                          <th className="p-2 border">Payment Type</th>
                          <th className="p-2 border">Amount</th>
                          <th className="p-2 border">Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="p-2 border">02/03/2025 03:26 am</td>
                          <td className="p-2 border">John Doe</td>
                          <td className="p-2 border">Cash</td>
                          <td className="p-2 border">$200.00</td>
                          <td className="p-2 border">Added 200</td>
                        </tr>
                        <tr>
                          <td className="p-2 border">02/03/2025 03:27 am</td>
                          <td className="p-2 border">John Doe</td>
                          <td className="p-2 border">Cash</td>
                          <td className="p-2 border">-$80.00</td>
                          <td className="p-2 border">Removed</td>
                        </tr>
                      </tbody>
                    </table> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PosRegisterDetailPage;
